import React from 'react';

import { STATIC_ROOT, LOGO_ROOT } from '../../../constants';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';
import SvgComponent from '../../../components/SvgComponent';

import './StepEbonComponent.scss';

const StepEbonComponent = ({ partner, parameters }) => {
    return (
        <div className="step-ebon">
            {parameters.map(param => (
                <div key={param.id}>
                    <h4 className="title">{param.title}</h4>
                    <div className="step-how-where-container">
                        {param.steps.map((step, index) => (
                            <div className="step-chevron" key={step.id}>
                                <div className="step">
                                    {step.visual ? (
                                        <img
                                            src={`${LOGO_ROOT}/${partner.logo}`}
                                            width="90"
                                            height="50"
                                            alt="logo"
                                        />
                                    ) : (
                                        <div className="step-icon">
                                            <span>{step.number}</span>
                                        </div>
                                    )}
                                    <p>{convertHtmlToReactDomWithParams(step.text)}</p>
                                </div>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/chevron.svg`}
                                    width="19"
                                    height="19"
                                    className={index === param.steps.length - 1 ? 'hidden' : ''}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
export default StepEbonComponent;



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/StepEbonComponent.js